<template>
  <div class="specificityWrap">
    <h4 class="subTitle">프로젝트 성격</h4>
    <specificity-item-list/>
  </div>
</template>

<script>
  import SpecificityItemList from "./SpecificityItemList";

  export default {
    name: "specificity",
    components : {
      SpecificityItemList

    }

  }
</script>

<style scoped lang="scss">
  @import "@/styles/ContactUs.scss";
  .specificityWrap{
    margin-bottom:4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/Specificity.vue